import { DatePickerElement } from 'react-hook-form-mui/date-pickers';
import { CmsEditableDateFieldData } from '@/services/cms/userDefinedForm/CmsEditableDateFieldData';

export type EditableCountryDropdownFieldProps = CmsEditableDateFieldData;

export const EditableDateField = (props: EditableCountryDropdownFieldProps) => (
    <DatePickerElement label={props.title} name={props.name} required={props.required} inputProps={{ fullWidth: true }} />
);
